import { BookingDetails } from '../domain/BookingDetails'
import { CancellationReason } from '../domain/CancellationReason'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-confirm-cancellation',
    templateUrl: './confirm-cancellation.component.html',
})
export class ConfirmCancellationComponent implements OnInit {

    @Input() bookingDetails!: BookingDetails
    @Output() cancelSelected = new EventEmitter<void>()
    @Output() confirmSelected = new EventEmitter<CancellationReason | null>()

    selectedCancellationReason: CancellationReason | null = null
    orderedCancellationReasons: CancellationReason[] = []

    constructor() { }

    ngOnInit() {
        this.orderedCancellationReasons = [...this.bookingDetails.cancellationReasons]
            .sort((a, b) => a.orderIndex - b.orderIndex)
    }

    onConfirm() {
        this.confirmSelected.emit(this.selectedCancellationReason)
    }
}
